import { createFileRoute } from "@tanstack/react-router";
import { DenomLandingPage } from "@/components/prize-bond/DenomLandingPage";
import { buildPrizeBondLandingHead } from "@/lib/prize-bond-landing-head";

const DENOM = 100;
const SLUG = "prize-bond-100-result-today";
const TITLE =
  "100 Prize Bond Result Today 2026 - Prize Bond Check Karne Ka Tarika - Check Prize Bond Online";
const DESC =
  "Rs. 100 prize bond result today Pakistan — smallest denomination checker. Single/bulk/range online with National Savings official data.";

const HOW_TO_STEPS = [
  { title: "Rs. 100 chip choose karein", body: "Denomination bar mein green Rs. 100 chip par tap karein — yeh sab se sasta bearer bond hai." },
  { title: "Single ya bulk mode", body: "Ek number ho to Single tab, kayi bonds ho to Bulk mein comma se separate karke paste karein." },
  { title: "Number confirm karein", body: "Rs. 100 bond ka number 6 digit hota hai — bond ke upper right corner par printed hota hai." },
  { title: "Check aur result", body: "'Check Karain' button dabate hi winners green highlight ho jate hain, doosre neeche list mein show hote hain." },
  { title: "Claim SBP se", body: "Chota inaam commercial bank branch se cash mile ga, bara inaam SBP branch se cross cheque ke through account mein aayega." },
];

const FAQS = [
  { q: "Rs. 100 prize bond ka result today kahan se dekhein?", a: "Upar checker mein Rs. 100 chip select karein aur bond number likh kar 'Check Karain' dabayein. Data National Savings Pakistan ki official Rs. 100 draw se sync hota hai — draw ke 24 hours ke andar upload ho jata hai." },
  { q: "100 wale prize bond ka pehla inaam kitna hai?", a: "First prize Rs. 7,00,000 (7 lakh) — 1 winner. Second prize Rs. 2,00,000 (2 lakh) — 3 winners. Third prize Rs. 1,000 — 1,199 winners. Yeh Pakistan ka sab se sasta prize bond hai." },
  { q: "Kya 100 rupay ke prize bond bearer hain?", a: "Ji haan, Rs. 100 bearer bond hai — CNIC ya registration ki zarurat nahi. Koi bhi cash mein SBP ya commercial bank se le sakta hai aur usi tarah cash mein wapis bhi kara sakta hai." },
  { q: "100 prize bond draw kab hoti hai saal mein?", a: "Rs. 100 draw quarterly hoti hai — February, May, August, November ke pehle hafte mein. Exact date National Savings pehle publish karta hai apne official calendar par." },
  { q: "Chotay bachon ke naam Rs. 100 bond le sakte hain?", a: "Haan — bearer bond hone ki wajah se koi CNIC bind nahi hoti, isliye parents apne bachon ke naam gift karne ke liye common tor par Rs. 100 bond khareedte hain." },
  { q: "Rs. 100 par bhi tax lagta hai jeetne par?", a: "Third prize Rs. 1,000 hai jo threshold Rs. 5,000 se neeche hai — is par koi tax nahi. Sirf first (Rs. 7 lakh) aur second (Rs. 2 lakh) par filer 15% aur non-filer 30% withholding tax lagta hai." },
  { q: "100 wale prize bond ki color coding kya hai?", a: "Rs. 100 bond ka color green hota hai — is ki wajah se pehchan mein aasani hoti hai. Har denomination ka alag color hai: 200 blue, 750 orange, 1500 pink, waghaira." },
  { q: "Kya Rs. 100 bond ka draw future mein band hone wala hai?", a: "Filhaal koi announcement nahi hai. Rs. 7,500 aur Rs. 15,000 bearer bonds December 2021 mein discontinue hue thay, lekin Rs. 100, 200, 750 aur 1500 bearer form mein continue hain." },
  { q: "Rs. 100 bond ka best strategy kya hai?", a: "Chunki chances of winning har draw mein low hain (1200 winners total), best strategy hai ke consistent 50-100 bonds rakhein aur har quarter check karein. Third prize Rs. 1,000 par bhi return of principal + Rs. 900 profit ho jata hai." },
  { q: "Bulk mein Rs. 100 bonds check karna free hai?", a: "Bilkul free — bulk mode mein 100 aur range mode mein 500 tak numbers ek click mein check kar sakte hain. Koi signup, subscription ya limit nahi hai." },
];

const RELATED = [
  { href: "/prize-bond-200-result-today", label: "Rs. 200 Prize Bond" },
  { href: "/prize-bond-list-750-today", label: "Rs. 750 Prize Bond" },
  { href: "/prize-bond-1500-result-today", label: "Rs. 1,500 Prize Bond" },
  { href: "/prize-bond-25000-result-today", label: "Rs. 25,000 Premium" },
  { href: "/prize-bond-40000-result-today", label: "Rs. 40,000 Premium" },
  { href: "/prize-bond", label: "All Prize Bonds Hub" },
];

export const Route = createFileRoute("/prize-bond-100-result-today")({
  head: () =>
    buildPrizeBondLandingHead({
      slug: SLUG,
      title: TITLE,
      description: DESC,
      denomination: DENOM,
      howToName: "How to check Rs. 100 Prize Bond result today",
      howToSteps: HOW_TO_STEPS,
      faqs: FAQS,
    }),
  component: Page,
});

function Page() {
  return (
    <DenomLandingPage
      denomination={DENOM}
      h1English="100 Prize Bond Result Today — Cheapest Bearer Bond Checker"
      h1Hinglish="100 Wala Prize Bond Ka Aaj Ka Result — Foran Nikaalain"
      introParagraphs={[
        "Rs. 100 Pakistan ka sab se sasta prize bond hai — sirf 100 rupay mein har quarter Rs. 7 lakh jackpot ka chance milta hai. Isi wajah se yeh bond bachon ke naam gift, chotay savers aur first-time buyers ke beech sab se popular hai. Is page par aap seedha aaj ki draw ka result seconds mein check kar sakte hain.",
        "Data National Savings Pakistan ki official Rs. 100 draw PDF se sync hota hai — as soon as State Bank draw complete karta hai, hamara system winners parse karke checker mein feed kar deta hai. Aap ko koi PDF search karne ya third-party channels ka wait karne ki zarurat nahi.",
        "Neeche checker ke baad Rs. 100 ki full prize structure, tax exemption, gifting strategy aur unique FAQs milengi — sirf 100 rupay wale bond ke user perspective se likhi hui.",
      ]}
      keyFacts={[
        { label: "1st Prize", value: "Rs. 7,00,000" },
        { label: "2nd Prize (×3)", value: "Rs. 2,00,000" },
        { label: "3rd Prize (×1199)", value: "Rs. 1,000" },
        { label: "Color", value: "Green · Bearer" },
      ]}
      sections={[
        {
          id: "why-100-bond",
          heading: "Rs. 100 Bond Kyun Popular Hai",
          body: (
            <>
              <p>
                Rs. 100 sab se accessible entry point hai prize bond system mein. Sirf 100 rupay mein aap ko Rs. 7 lakh
                jackpot ka chance milta hai aur agar third prize (Rs. 1,000) bhi jeet gaye to bhi 10x return hai. Bachon
                ke naam gift karne ke liye is liye ideal hai ke bearer form hai aur koi CNIC binding nahi hai — parents
                easily hand over kar sakte hain.
              </p>
              <p>
                Chotay traders aur salaried log 50-100 Rs. 100 bonds ki collection rakhte hain — capital 5,000-10,000
                rupay lock hota hai, principal 100% safe hai (SBP guarantee), aur upside unlimited hai.
              </p>
            </>
          ),
        },
        {
          id: "tax-free-third",
          heading: "Tax-Free Third Prize — Rs. 100 Ka Chota Sa Advantage",
          body: (
            <>
              <p>
                Pakistan mein prize bond ke prize par withholding tax sirf tab lagta hai jab amount Rs. 5,000 se upar ho.
                Rs. 100 bond ka third prize Rs. 1,000 hai — is par filer ho ya non-filer, koi tax nahi katega. Yeh
                Rs. 100 bond ka unique advantage hai jo doosri kisi bhi denomination par nahi milta.
              </p>
            </>
          ),
        },
      ]}
      howToSteps={HOW_TO_STEPS}
      faqs={FAQS}
      relatedLinks={RELATED}
    />
  );
}
